module.exports = __webpack_public_path__ + "static/media/grafic.bf6cc1be.svg";